import { Component, OnInit } from "@angular/core";
import { catchError, retry } from "rxjs/operators";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";
import { SystemUtils } from "../utils/system.utils";

@Component({
  selector: "app-infra-maintenance",
  templateUrl: "./infra-maintenance.component.html",
  styleUrls: ["./infra-maintenance.component.css"],
  providers: [RestService],
})
export class InfraMaintenanceComponent implements OnInit {
  isSuccess: boolean = false;
  isFailure: boolean = false;
  isLoading: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";
  envList: any = "";
  systemList: any = [];
  acutalSystemList: any = [];
  default_env: any = "";
  systemID: any = "";
  noofevnActivity: any = 0;
  noofsysActivity: any = 0;
  categoryName: any = "";
  envname: any = "";
  SID: any = "";
  masterEnvId: any = "";

  isViewOccurrenceClick: boolean = false;
  isConfirmClear: boolean = false;
  seriesOnly = false;

  constructor(private _restService: RestService, private router: Router) {}

  ngOnInit() {
    (this.isLoading = true), (this.noofevnActivity = 0);
    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.envList = f.EnvList),
          (this.envname = this.envList[0].Environment_Name),
          (this.default_env = this.envList[0].id),
          this.envList.filter((m: any) =>
            parseInt(m.id) === parseInt(this.default_env)
              ? (this.masterEnvId = m.MasterEnvId)
              : ""
          ),
          this.callbackgetlist(),
          (this.isLoading = false)
        )
      );
  }

  changeSeriesFlag(value: boolean){
    this.seriesOnly = value;
  }

  callbackgetlist = () => {
    this._restService
      .getMaintenceList(this.default_env, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (d: any) => (
          console.log("getMaintenceList --->", d),
          (this.noofevnActivity = 0),
          (this.systemList = d.systemAccess),
          (SystemUtils.sortSystemAccess(this.systemList)),
          (this.acutalSystemList = d.systemAccess),
          this.systemList.filter((f: any) => {
            f.LevelNumber === 1
              ? (this.noofevnActivity = this.noofevnActivity + f.activityCount)
              : "";
          }),
          this.systemList.map(
            (a: any) => (
              (a.isSelected = false),
              a.hasOwnProperty("children")
                ? a.children.map(
                    (b: any) => (
                      (b.isSelected = false),
                      b.hasOwnProperty("children")
                        ? b.children.map(
                            (c: any) => (
                              (c.isSelected = false),
                              c.hasOwnProperty("children")
                                ? c.children.map(
                                    (d: any) => (
                                      (d.isSelected = false),
                                      d.hasOwnProperty("children")
                                        ? d.children.map(
                                            (f: any) => (
                                              (f.isSelected = false),
                                              f.hasOwnProperty("children")
                                                ? f.children.map(
                                                    (g: any) => (
                                                      (g.isSelected = false),
                                                      g.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? g.children.map(
                                                            (h: any) => (
                                                              (h.isSelected = false),
                                                              h.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? h.children.map(
                                                                    (
                                                                      j: any
                                                                    ) => (
                                                                      (j.isSelected = false),
                                                                      j.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? j.children.map(
                                                                            (
                                                                              k: any
                                                                            ) =>
                                                                              (k.isSelected = false)
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  )
                : ""
            )
          ),
          console.log("this.noofevnActivity", this.noofevnActivity)
        )
      );
  };

  filterEvent() {
    console.log("Filter clicked");
  }

  searchKeyword(e: any) {
    let v = e.target.value.toLowerCase();
    let sortedList: any = [];

    if (v === "") {
      this.systemList = this.acutalSystemList;
    } else {
      this.acutalSystemList.map((f: any) =>
        f.LevelNumber === 1 && f.alias !== ""
          ? f.alias.toLowerCase().includes(v)
            ? sortedList.push(f)
            : ""
          : f.category_Name.toLowerCase().includes(v)
          ? sortedList.push(f)
          : ""
      );
      this.systemList = sortedList;
    }
  }

  selectEnvironment(e: any) {
    let environment = e.target.value.toString();
    this.default_env = environment;

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(this.default_env)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    this.noofevnActivity = 0;
    this.envname = e.target.options[e.target.options.selectedIndex].text;
    console.log(e),
      (this.isLoading = true),
      this._restService
        .getMaintenceList(this.default_env, this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (d: any) => (
            console.log("getMaintenceList --->", d),
            (this.isLoading = false),
            (this.systemList = d.systemAccess),
            (SystemUtils.sortSystemAccess(this.systemList)),
            (this.acutalSystemList = d.systemAccess),
            this.systemList.filter((f: any) => {
              f.LevelNumber === 1
                ? (this.noofevnActivity =
                    this.noofevnActivity + f.activityCount)
                : "";
            }),
            this.systemList.map(
              (a: any) => (
                (a.isSelected = false),
                a.hasOwnProperty("children")
                  ? a.children.map(
                      (b: any) => (
                        (b.isSelected = false),
                        b.hasOwnProperty("children")
                          ? b.children.map(
                              (c: any) => (
                                (c.isSelected = false),
                                c.hasOwnProperty("children")
                                  ? c.children.map(
                                      (d: any) => (
                                        (d.isSelected = false),
                                        d.hasOwnProperty("children")
                                          ? d.children.map(
                                              (f: any) => (
                                                (f.isSelected = false),
                                                f.hasOwnProperty("children")
                                                  ? f.children.map(
                                                      (g: any) => (
                                                        (g.isSelected = false),
                                                        g.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? g.children.map(
                                                              (h: any) => (
                                                                (h.isSelected = false),
                                                                h.hasOwnProperty(
                                                                  "children"
                                                                )
                                                                  ? h.children.map(
                                                                      (
                                                                        j: any
                                                                      ) => (
                                                                        (j.isSelected = false),
                                                                        j.hasOwnProperty(
                                                                          "children"
                                                                        )
                                                                          ? j.children.map(
                                                                              (
                                                                                k: any
                                                                              ) =>
                                                                                (k.isSelected = false)
                                                                            )
                                                                          : ""
                                                                      )
                                                                    )
                                                                  : ""
                                                              )
                                                            )
                                                          : ""
                                                      )
                                                    )
                                                  : ""
                                              )
                                            )
                                          : ""
                                      )
                                    )
                                  : ""
                              )
                            )
                          : ""
                      )
                    )
                  : ""
              )
            ),
            (this.isLoading = false),
            console.log("this.noofevnActivity", this.noofevnActivity)
          )
        );
  }

  systemActivityCount(id: any, count: any) {
    this.noofsysActivity = count;
    this.systemList.map(
      (a: any) => (
        a.categoryId === id ? (a.isSelected = true) : (a.isSelected = false),
        a.hasOwnProperty("children")
          ? a.children.map(
              (b: any) => (
                b.categoryId === id
                  ? (b.isSelected = true)
                  : (b.isSelected = false),
                b.hasOwnProperty("children")
                  ? b.children.map(
                      (c: any) => (
                        c.categoryId === id
                          ? (c.isSelected = true)
                          : (c.isSelected = false),
                        c.hasOwnProperty("children")
                          ? c.children.map(
                              (d: any) => (
                                d.categoryId === id
                                  ? (d.isSelected = true)
                                  : (d.isSelected = false),
                                d.hasOwnProperty("children")
                                  ? d.children.map(
                                      (f: any) => (
                                        f.categoryId === id
                                          ? (f.isSelected = true)
                                          : (f.isSelected = false),
                                        f.hasOwnProperty("children")
                                          ? f.children.map(
                                              (g: any) => (
                                                g.categoryId === id
                                                  ? (g.isSelected = true)
                                                  : (g.isSelected = false),
                                                g.hasOwnProperty("children")
                                                  ? g.children.map(
                                                      (h: any) => (
                                                        h.categoryId === id
                                                          ? (h.isSelected = true)
                                                          : (h.isSelected = false),
                                                        h.hasOwnProperty(
                                                          "children"
                                                        )
                                                          ? h.children.map(
                                                              (j: any) => (
                                                                j.categoryId ===
                                                                id
                                                                  ? (j.isSelected = true)
                                                                  : (j.isSelected = false),
                                                                j.hasOwnProperty(
                                                                  "children"
                                                                )
                                                                  ? j.children.map(
                                                                      (
                                                                        k: any
                                                                      ) =>
                                                                        k.categoryId ===
                                                                        id
                                                                          ? (k.isSelected = true)
                                                                          : (k.isSelected = false)
                                                                    )
                                                                  : ""
                                                              )
                                                            )
                                                          : ""
                                                      )
                                                    )
                                                  : ""
                                              )
                                            )
                                          : ""
                                      )
                                    )
                                  : ""
                              )
                            )
                          : ""
                      )
                    )
                  : ""
              )
            )
          : ""
      )
    );

    console.log("System ------>>>>>", this.systemList);
  }

  clearOccurrence(sid: any) {
    this.SID = sid;
    this.isConfirmClear = true;
  }

  ConfirmClearEvent() {
    this.isConfirmClear = false;
    this.isLoading = true;
    this._restService
      .delAllMOccurance(this.default_env, this.SID, this.masterEnvId)
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          this.callbackgetlist(),
          (this.isSuccess = true),
          (this.successMessage = f.StatusInfo),
          (this.isLoading = false)
        )
      );
  }

  CancelClearEvent() {
    this.isConfirmClear = false;
  }

  viewOccurrence(id: any) {
    this.isViewOccurrenceClick = true;
    this.systemID = id;
  }

  backtoList() {
    this.isViewOccurrenceClick = false;
    this.noofevnActivity = 0;
    this.systemList = [];
    (this.isLoading = true),
      this._restService
        .environmentList()
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (f: any) => (
            (this.envList = f.EnvList),
            (this.envname = this.envList[0].Environment_Name),
            (this.default_env = this.envList[0].id),
            this._restService
              .getMaintenceList(this.default_env, this.masterEnvId)
              .pipe(
                catchError((e) => {
                  (this.isLoading = false),
                    (this.isFailure = true),
                    (this.failureMessage = e.error.StatusInfo);
                  return e;
                })
              )
              .subscribe(
                (d: any) => (
                  console.log("getMaintenceList --->", d),
                  (this.isLoading = false),
                  (this.systemList = d.systemAccess),
                  (SystemUtils.sortSystemAccess(this.systemList)),
                  (this.acutalSystemList = d.systemAccess),
                  this.systemList.filter((f: any) => {
                    f.LevelNumber === 1
                      ? (this.noofevnActivity =
                          this.noofevnActivity + f.activityCount)
                      : "";
                  }),
                  this.systemList.map(
                    (a: any) => (
                      (a.isSelected = false),
                      a.hasOwnProperty("children")
                        ? a.children.map(
                            (b: any) => (
                              (b.isSelected = false),
                              b.hasOwnProperty("children")
                                ? b.children.map(
                                    (c: any) => (
                                      (c.isSelected = false),
                                      c.hasOwnProperty("children")
                                        ? c.children.map(
                                            (d: any) => (
                                              (d.isSelected = false),
                                              d.hasOwnProperty("children")
                                                ? d.children.map(
                                                    (f: any) => (
                                                      (f.isSelected = false),
                                                      f.hasOwnProperty(
                                                        "children"
                                                      )
                                                        ? f.children.map(
                                                            (g: any) => (
                                                              (g.isSelected = false),
                                                              g.hasOwnProperty(
                                                                "children"
                                                              )
                                                                ? g.children.map(
                                                                    (
                                                                      h: any
                                                                    ) => (
                                                                      (h.isSelected = false),
                                                                      h.hasOwnProperty(
                                                                        "children"
                                                                      )
                                                                        ? h.children.map(
                                                                            (
                                                                              j: any
                                                                            ) => (
                                                                              (j.isSelected = false),
                                                                              j.hasOwnProperty(
                                                                                "children"
                                                                              )
                                                                                ? j.children.map(
                                                                                    (
                                                                                      k: any
                                                                                    ) =>
                                                                                      (k.isSelected = false)
                                                                                  )
                                                                                : ""
                                                                            )
                                                                          )
                                                                        : ""
                                                                    )
                                                                  )
                                                                : ""
                                                            )
                                                          )
                                                        : ""
                                                    )
                                                  )
                                                : ""
                                            )
                                          )
                                        : ""
                                    )
                                  )
                                : ""
                            )
                          )
                        : ""
                    )
                  ),
                  console.log("this.noofevnActivity", this.noofevnActivity)
                )
              )
          )
        );
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }
}
